
import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface PulseLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'color' | 'white' | 'text';
  className?: string;
}

const PulseLogo: React.FC<PulseLogoProps> = ({ 
  size = 'md', 
  variant = 'color',
  className = ""
}) => {
  // Text logo usando a fonte Dancing Script
  if (variant === 'text') {
    const textSizes = {
      sm: 'text-2xl',
      md: 'text-4xl', 
      lg: 'text-6xl',
      xl: 'text-8xl'
    };
    
    return (
      <div className={`font-brand font-bold text-primary ${textSizes[size]} ${className}`}>
        Pulse
      </div>
    );
  }

  const { theme } = useTheme();

  // Logo com imagem
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16',
    xl: 'h-24'
  };

  const logoPath = theme === 'dark' || variant === 'white' 
    ? 'https://zbvjxryqzrygkixfuidj.supabase.co/storage/v1/object/public/admin_pics/Logos/logov2_pulse_rosaclaro.png.png'
    : 'https://zbvjxryqzrygkixfuidj.supabase.co/storage/v1/object/public/admin_pics/Logos/logov2_pulse_vermelho.png';

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <img 
        src={logoPath} 
        alt="Pulse Logo" 
        className="h-full object-contain"
      />
    </div>
  );
};

export default PulseLogo;
